var render = function render(){var _vm=this,_c=_vm._self._c;return _c('role-home-page',{attrs:{"customeRoadMap":['首页'],"initHook":_vm.init,"destryHook":_vm.destroy}})
}
var staticRenderFns = []

export { render, staticRenderFns }